var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TableCell, TableRow } from '../../common';
import { ExpandableRowLabel } from '../../common/tableHierarchy';
import { useCurrencySymbol } from '../../hooks/useCurrencyOptions';
import { QueueType } from '../../multiskill/types';
import { useResourcingContext } from '../../report/hooks';
import { useDisplayModeParams } from '../../report/selectors';
import { FirstCell, STICKIES } from '../annualTable';
import { CURRENCY, DECIMAL_VALUE, HIERARCHY_LEVEL, NEST_LEVEL, PERCENTAGES, TOTAL_ROW_COLOR, } from '../constants';
import { useSelectCurrency } from '../selectors';
import { getChunkBaselineValue, getExpandChildren, getHighlightBorder, getScenarioCellColor } from './utils';
export var TotalSummaryRow = function (_a) {
    var label = _a.label, valueKey = _a.valueKey, data = _a.data, chunkSize = _a.chunkSize, _b = _a.showVariance, showVariance = _b === void 0 ? true : _b, expanded = _a.expanded, onToggle = _a.onToggle, decimal = _a.decimal;
    var isPercentages = useResourcingContext().isPercentages;
    var displayMode = useDisplayModeParams()[0];
    var currency = useSelectCurrency();
    var typedValueKey = valueKey;
    var isCurrencyRow = CURRENCY.includes(typedValueKey);
    var _c = useCurrencySymbol(isCurrencyRow ? currency : undefined), currencyPrefix = _c.prefix, currencySuffix = _c.suffix;
    var varianceDecimalPlaces;
    if (typedValueKey === 'costPerWork') {
        varianceDecimalPlaces = 2;
    }
    else if (isCurrencyRow) {
        varianceDecimalPlaces = 0;
    }
    var varianceOptions = { decimalPlaces: varianceDecimalPlaces, currencyPrefix: currencyPrefix, currencySuffix: currencySuffix };
    var totalPerScenario = data.map(function (s) { var _a; return (_a = s[valueKey]) !== null && _a !== void 0 ? _a : null; });
    return (_jsxs(TableRow, { children: [_jsx(FirstCell, __assign({ "aria-label": NEST_LEVEL[HIERARCHY_LEVEL.total], stickySizes: STICKIES, bold: true, color: TOTAL_ROW_COLOR }, { children: _jsx(ExpandableRowLabel, __assign({ expanded: expanded, onToggle: onToggle, bold: true }, { children: label })) })), totalPerScenario.map(function (value, index, arr) {
                var _a, _b, _c;
                var baseValue = (_a = getChunkBaselineValue(totalPerScenario, index, chunkSize)) !== null && _a !== void 0 ? _a : null;
                var isPercentage = PERCENTAGES.includes(typedValueKey);
                var isMultiskillScenario = ((_b = data[index]) === null || _b === void 0 ? void 0 : _b.dataType) === QueueType.Multiskill;
                return (_jsx(TableCell, { colSpan: 2, value: value, decimal: (_c = decimal !== null && decimal !== void 0 ? decimal : DECIMAL_VALUE[typedValueKey]) !== null && _c !== void 0 ? _c : 0, percentage: isPercentage, bold: true, currency: isCurrencyRow ? currency : undefined, color: getScenarioCellColor(data[index]), useColorValue: isMultiskillScenario, highlightBorder: getHighlightBorder(index, arr.length, chunkSize), expandchildren: showVariance
                        ? getExpandChildren(displayMode, baseValue, value, isPercentages, varianceOptions)
                        : undefined }, "total-summary-".concat(label, "-").concat(index)));
            })] }));
};
